import { render, staticRenderFns } from "./TermsCheck.vue?vue&type=template&id=df8d4a6e&"
import script from "./TermsCheck.vue?vue&type=script&lang=js&"
export * from "./TermsCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports